module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.31511/images/table-two-rows.svg"